import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../CommonCssFiles/planstyle.css";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { changeDateFormat, getDate } from "../helper/common";
import "./HDFC.css";
import { useSelector, useDispatch } from "react-redux";
import { FormControl, FormLabel } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import {
  selectProposal,
  updateHDFCQuestion,
  updateHDFCPersion,
  updateHDFCQAlist,
  selectHDFCcheckedQuestion,
  selectHDFCcheckedPersion,
} from "../redux/Slice";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
} from "@mui/material";

const search = window.location.search;
const params = new URLSearchParams(search);
const unique_id = params.get("req_id");
const plan_id = params.get("plan_id");
const c_id = params.get("c_id");

export const HDFCQuestionAnswerIndividual = ({
  data,
  index,
  insuredData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  medErrors,
  setMedErrors,
}) => {
  const updateHDFCQuestion = ({ val }) => {
    setHDFCcheckedQuestion((prevState) => {
      const updatedState = { ...prevState };

      if (updatedState.hasOwnProperty(val)) {
        delete updatedState[val];
      } else {
        updatedState[val] = {};
      }

      return updatedState;
    });
  };

  useEffect(() => {
    if (medErrors.length > 0) {
      const firstErrorElement = document.querySelector(
        `[data-question-id="${medErrors[0]}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [medErrors]);

  return (
    <>
      <div
        className="col-md-12"
        style={{ paddingLeft: "0px", minWidth: "250px" }}
        data-question-id={data.question_id}
      >
        <div
          className="col-md-12 pmd-hdfc"
          style={{
            backgroundColor: medErrors.includes(data.question_id)
              ? "#ffebeb"
              : "transparent",
            border: medErrors.includes(data.question_id)
              ? "1px solid #ff4d4d"
              : "1px solid #ddd",
            padding: "10px",
            borderRadius: "8px",
            transition: "all 0.3s ease-in-out",
            boxShadow: medErrors.includes(data.question_id)
              ? "0px 0px 3px rgba(255, 77, 77, 0.6)"
              : "none",
          }}
        >
          <FormControlLabel
            value={data.question_id}
            onChange={(e) => {
              const isChecked = e.target.checked;
              updateHDFCQuestion({ val: e.target.value });

              if (!isChecked) {
                setMedErrors((prevErrors) =>
                  prevErrors.filter((id) => id !== data.question_id)
                );
              }
            }}
            control={
              <Checkbox
                sx={{
                  color: medErrors.includes(data.question_id)
                    ? "#d32f2f"
                    : "#2959b8",
                  "&.Mui-checked": {
                    color: medErrors.includes(data.question_id)
                      ? "#d32f2f"
                      : "#2959b8",
                  },
                }}
              />
            }
            label={"Q. " + data.question}
            checked={HDFCcheckedQuestion.hasOwnProperty(data.question_id)}
            style={{
              color: medErrors.includes(data.question_id)
                ? "rgb(164 35 35)"
                : "#333",
              fontWeight: medErrors.includes(data.question_id) ? "600" : "400",
            }}
          />
        </div>
      </div>
    </>
  );
};

// export const HDFCPersionIndividual = ({
//   data,
//   persion,
//   pindex,
//   proposerData,
//   HDFCcheckedQuestion,
//   setHDFCcheckedQuestion,
// }) => {
//   const [selectedGender, setSelectedGender] = useState(
//     localStorage.getItem("selectedType")
//   );

//   const updateHDFCPerson = (payload) => {
//     const { question_id, pindex } = payload;
//     setHDFCcheckedQuestion((prevState) => {
//       const updatedState = { ...prevState };

//       if (!updatedState[question_id]) {
//         updatedState[question_id] = {};
//       }

//       const question = updatedState[question_id];

//       if (question.hasOwnProperty(pindex)) {
//         delete question[pindex];
//       } else {
//         question[pindex] = [];
//       }

//       return updatedState;
//     });
//   };

//   const check = () => {
//     if (HDFCcheckedQuestion.hasOwnProperty(data.question_id)) {
//       if (HDFCcheckedQuestion[data.question_id].hasOwnProperty(pindex)) {
//         return true;
//       }
//     }
//     return false;
//   };

//   useEffect(() => {
//     setSelectedGender(localStorage.getItem("selectedType"));
//   }, []);

//   const allowedRelationsByGender = {
//     M: ["Mother", "Grand Mother", "Sister", "Wife", "Mother In Law"],
//     F: ["Mother", "Grand Mother", "Sister", "Wife", "Mother In Law", "Self"],
//   };

//   const allowedRelations = allowedRelationsByGender[selectedGender] || [];
//   const personPresent = allowedRelations.includes(persion?.InsuredRelation);

//   const getDisplayStyle = () => {
//     const search = window.location.search;
//     const params = new URLSearchParams(search);
//     const plan_id = params.get("plan_id");
//     const c_id = params.get("c_id");

//     const isQuestion6 = data.question_id == 6;
//     const isHDFC = c_id == "hdfc";
//     const isFamilyPlan = plan_id == "Family";
//     const isIndividualPlan = plan_id == "Individual";

//     if (isQuestion6 && isHDFC) {
//       if (isFamilyPlan && !personPresent) {
//         return "none";
//       } else if (isIndividualPlan && !personPresent) {
//         return "none";
//       }
//     }

//     return "block";
//   };

//   console.log("hi");

//   return (
//     <>
//       <div
//         className={`same-section-med col-md-6 ${
//           data.question_id == 6 &&
//           c_id == "hdfc" &&
//           plan_id == "Individual" &&
//           !personPresent
//             ? "hidden-section"
//             : "visible-section"
//         }`}
//       >
//         <div
//           hidden={!HDFCcheckedQuestion.hasOwnProperty(data.question_id)}
//           onClick={(e) => {
//             if (
//               data.question_id == 6 &&
//               c_id == "hdfc" &&
//               plan_id == "Individual" &&
//               !personPresent
//             ) {
//               // Prevent the click if condition is met
//               e.stopPropagation();
//               return;
//             } else {
//               updateHDFCPerson({
//                 pindex: pindex,
//                 question_id: data.question_id,
//               });
//             }
//           }}
//           className={`clickable-box ${
//             data.question_id == 6 &&
//             c_id == "hdfc" &&
//             plan_id == "Individual" &&
//             !personPresent
//               ? "disabled-box"
//               : ""
//           }`}
//           style={{
//             padding: "10px",
//             borderRadius: "5px",
//           }}
//         >
//           <div
//             // className={`${
//             //   check() ? "sumbox all-med-sum col-md-12" : "sumbox all-med-addon"
//             // } sumbox-center`}

//             className={
//               data.question_id == 6 &&
//               c_id == "hdfc" &&
//               plan_id == "Individual" &&
//               !personPresent
//                 ? "sumbox disabled-box"
//                 : check()
//                 ? "sumbox all-med-sum col-md-12"
//                 : "sumbox all-med-addon"
//             }
//           >
//             <div>
//               <span className={check() ? "para" : "para-unchecked"}>
//                 {proposerData?.InsuredDetail[pindex]?.InsuredName}

//                 {data.question_id == 6 &&
//                 c_id == "hdfc" &&
//                 plan_id == "Individual" &&
//                 !personPresent ? (
//                   <span>({persion?.InsuredRelation})</span>
//                 ) : (
//                   <span className={check() ? "para-relation" : "para-rel"}>
//                     ({persion?.InsuredRelation})
//                   </span>
//                 )}

//                 {data.question_id == 6 &&
//                 c_id == "hdfc" &&
//                 plan_id == "Individual" &&
//                 !personPresent ? (
//                   <span>(Not Applicable)</span>
//                 ) : (
//                   ""
//                 )}
//               </span>
//             </div>
//           </div>
//         </div>

//         {data?.get_child_question?.map((child_data) => {
//           return (
//             <SubQuestionAnswer
//               key={child_data.question_id}
//               data={child_data}
//               parentData={data}
//               pindex={pindex}
//               proposerData={proposerData}
//               HDFCcheckedQuestion={HDFCcheckedQuestion}
//               setHDFCcheckedQuestion={setHDFCcheckedQuestion}
//             />
//           );
//         })}
//       </div>
//     </>
//   );
// };

export const HDFCPersionIndividual = ({
  data,
  persion,
  pindex,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
}) => {
  // Get query params
  const params = new URLSearchParams(window.location.search);
  const plan_id = params.get("plan_id");
  const c_id = params.get("c_id");

  const [selectedGender, setSelectedGender] = useState(
    localStorage.getItem("selectedType") || "M"
  );

  useEffect(() => {
    const storedGender = localStorage.getItem("selectedType");
    if (storedGender) {
      setSelectedGender(storedGender);
    }
  }, []);

  const updateHDFCPerson = (payload) => {
    const { question_id, pindex } = payload;
    setHDFCcheckedQuestion((prevState) => {
      const updatedState = { ...prevState };

      if (!updatedState[question_id]) {
        updatedState[question_id] = {};
      }

      const question = updatedState[question_id];

      if (question.hasOwnProperty(pindex)) {
        delete question[pindex];
      } else {
        question[pindex] = [];
      }

      return updatedState;
    });
  };

  const check = () => {
    return (
      HDFCcheckedQuestion?.[data.question_id]?.hasOwnProperty(pindex) ?? false
    );
  };

  const allowedRelationsByGender = {
    M: [
      "Mother",
      "Grand Mother",
      "Sister",
      "Wife",
      "Mother In Law",
      "Daughter",
    ],
    F: [
      "Mother",
      "Grand Mother",
      "Sister",
      "Wife",
      "Mother In Law",
      "Self",
      "Daughter",
    ],
  };

  const allowedRelations = allowedRelationsByGender[selectedGender] || [];
  const personPresent = allowedRelations.includes(persion?.InsuredRelation);

  // If required values are not yet loaded, don't render anything
  if (!selectedGender || !plan_id || !c_id) {
    return null;
  }

  const shouldHide =
    data.question_id == 6 &&
    c_id === "hdfc" &&
    plan_id === "Individual" &&
    !personPresent;

  return (
    <div
      className={`same-section-med col-md-6 ${
        shouldHide ? "hidden-section" : "visible-section"
      }`}
    >
      <div
        hidden={!HDFCcheckedQuestion?.hasOwnProperty(data.question_id)}
        onClick={(e) => {
          if (shouldHide) {
            e.stopPropagation();
            return;
          }
          updateHDFCPerson({
            pindex,
            question_id: data.question_id,
          });
        }}
        className={`clickable-box ${shouldHide ? "disabled-box" : ""}`}
        style={{
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <div
          className={
            shouldHide
              ? "sumbox disabled-box"
              : check()
              ? "sumbox all-med-sum col-md-12"
              : "sumbox all-med-addon"
          }
        >
          <div>
            <span className={check() ? "para" : "para-unchecked"}>
              {proposerData?.InsuredDetail[pindex]?.InsuredName}
              <span className={check() ? "para-relation" : "para-rel"}>
                ({persion?.InsuredRelation})
              </span>
              {shouldHide && <span>(Not Applicable)</span>}
            </span>
          </div>
        </div>
      </div>

      {data?.get_child_question?.map((child_data) => (
        <SubQuestionAnswer
          key={child_data.question_id}
          data={child_data}
          parentData={data}
          pindex={pindex}
          proposerData={proposerData}
          HDFCcheckedQuestion={HDFCcheckedQuestion}
          setHDFCcheckedQuestion={setHDFCcheckedQuestion}
        />
      ))}
    </div>
  );
};

export const SubQuestionAnswer = ({
  data,
  pindex,
  parentData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
}) => {
  const proposalData = useSelector(selectProposal);

  const dispatch = useDispatch();

  const check = () => {
    if (HDFCcheckedQuestion.hasOwnProperty(parentData.question_id)) {
      if (HDFCcheckedQuestion[parentData.question_id].hasOwnProperty(pindex)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const [first, setFirst] = useState([]);

  useEffect(() => {
    const keysToCheck = [6, 6];
    const filteredObjects = keysToCheck
      .filter((key) => HDFCcheckedQuestion.hasOwnProperty(key))
      .map((key) => HDFCcheckedQuestion[key])
      .flat();

    setFirst(filteredObjects);
  }, []);

  const getDeliveryDate = () => {
    if (first.length > 0) {
      return first[0];
    }
  };

  const datadate = getDeliveryDate();

  let deliveryDates = [];
  for (const key in datadate) {
    if (datadate.hasOwnProperty(key)) {
      const questions = datadate[key];

      questions.forEach((question) => {
        if (question.Options && question.Options.length > 0) {
          question.Options.forEach((option) => {
            if (option.DeliveryDate) {
              deliveryDates.push(option.DeliveryDate);
            }
          });
        }
      });
    }
  }

  function HDFCquestionExist(qa, qid) {
    for (let i = 0; i < qa.length; i++) {
      if (qa[i].QuestionId == qid) {
        return true;
        break;
      }
    }
    return false;
  }
  function HDFCgetAnswerSet(qdata, name, value, parentQid) {
    if (parentQid == "1") {
      return {
        OptionId: qdata.question_id,
        OptionText: qdata.question,
        ExactDiagnosis: name == "ExactDiagnosis" ? value : "",
        ConsultationDate: name == "ConsultationDate" ? value : "",
        DiagnosisDate: name == "DiagnosisDate" ? value : "",
        CurrentStatus: name == "CurrentStatus" ? value : "",
        LineOfManagement: name == "LineOfManagement" ? value : "",
        TreatmentDetails: name == "TreatmentDetails" ? value : "",
      };
    } else if (parentQid == "2") {
      if (qdata.question_id == "17") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          ExactDiagnosis: name == "ExactDiagnosis" ? value : "",
          CurrentStatus: name == "CurrentStatus" ? value : "",
          DiagnosisDate: name == "DiagnosisDate" ? value : "",
          SurgeryDate: name == "SurgeryDate" ? value : "",
          SurgeryDetails: name == "SurgeryDetails" ? value : "",
        };
      } else if (qdata.question_id == "18") {
        return {
          OptionId: qdata.question_id,
          OptionText: "No",
          ExactDiagnosis: name == "",
          CurrentStatus: name == "",
          DiagnosisDate: name == "",
          SurgeryDate: name == "",
          SurgeryDetails: name == "",
        };
      }
    } else if (parentQid == "3") {
      if (qdata.question_id == "19") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          ExactDiagnosis: name == "ExactDiagnosis" ? value : "",
          DiagnosisDate: name == "DiagnosisDate" ? value : "",
          ConsultationDate: name == "ConsultationDate" ? value : "",
          CurrentStatus: name == "CurrentStatus" ? value : "",
          TreatmentDetails: name == "TreatmentDetails" ? value : "",
        };
      } else {
        return {
          OptionId: qdata.question_id,
          OptionText: "No",
          ExactDiagnosis: name == "",
          DiagnosisDate: name == "",
          ConsultationDate: name == "",
          CurrentStatus: name == "",
          TreatmentDetails: name == "",
        };
      }
    } else if (parentQid == "4") {
      if (qdata.question_id == "21") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          TestFinding: name == "TestFinding" ? value : "",
          TestDate: name == "TestDate" ? value : "",
          TypeOfTest: name == "TypeOfTest" ? value : "",
        };
      } else {
        return {
          OptionId: qdata.question_id,
          OptionText: "No",
          TestFinding: name == "",
          TestDate: name == "",
          TypeOfTest: name == "",
        };
      }
    } else if (parentQid == "5") {
      if (qdata.question_id == "23") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          ExactDiagnosis: name == "ExactDiagnosis" ? value : "",
          DiagnosisDate: name == "DiagnosisDate" ? value : "",
          ConsultationDate: name == "ConsultationDate" ? value : "",
          CurrentStatus: name == "CurrentStatus" ? value : "",
          TreatmentDetails: name == "TreatmentDetails" ? value : "",
          LineOfManagement: name == "LineOfManagement" ? value : "",
        };
      } else {
        return {
          OptionId: qdata.question_id,
          OptionText: "No",
          ExactDiagnosis: name == "",
          DiagnosisDate: name == "",
          ConsultationDate: name == "",
          CurrentStatus: name == "",
          TreatmentDetails: name == "",
          LineOfManagement: name == "",
        };
      }
    } else if (parentQid == "6") {
      if (qdata.question_id == "25") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Yes",
          DeliveryDate: name == "DeliveryDate" ? value : "",
        };
      } else {
        return {
          OptionId: qdata.question_id,
          OptionText: "No",
          DeliveryDate: name == "",
        };
      }
    } else if (
      ["79", "80", "81", "82", "83", "84", "85", "86"].includes(parentQid)
    ) {
      if (parentQid == "85") {
        return {
          OptionId: qdata.question_id,
          OptionText: "Visual / Hearing  disability",
        };
      } else {
        return {
          OptionId: qdata.question_id,
          OptionText: qdata.question,
        };
      }
    }
  }

  const updateHDFCQAlist = (payload) => {
    const { parentqData, pindex, qdata, name, value } = payload;
    const parentQid = parentqData.question_id;

    // console.log("update payload", value);

    setHDFCcheckedQuestion((prevState) => {
      const updatedState = { ...prevState };

      if (!updatedState[parentQid]) {
        updatedState[parentQid] = {};
      }

      const question = updatedState[parentQid];

      if (!question[pindex]) {
        question[pindex] = [];
      }

      const qa = question[pindex];

      const newObj = {
        QuestionId: parentqData.question_id,
        QuestionText: parentqData.question,
        Options: [HDFCgetAnswerSet(qdata, name, value, parentQid)],
      };

      if (!HDFCquestionExist(qa, parentQid)) {
        qa.push(newObj);
      } else {
        const objKey = qa.findIndex((item) => item.QuestionId == parentQid);
        const options = qa[objKey]["Options"];
        const optionIndex = options.findIndex(
          (item) => item.OptionId == qdata.question_id
        );

        if (optionIndex === -1) {
          options.push(HDFCgetAnswerSet(qdata, name, value, parentQid));
        } else {
          options[optionIndex][name] = value;
        }

        updatedState[parentQid][pindex] = qa
          .map((question) => ({
            ...question,
            Options: question.Options.filter((option) => {
              const keys = Object.keys(option).filter(
                (key) => key !== "OptionId" && key !== "OptionText"
              );
              return !keys.every((key) => option[key] === "");
            }),
          }))
          .filter((question) => question.Options.length > 0);
      }
      // console.log("updatedstate", updatedState);
      return updatedState;
    });
  };

  return (
    <>
      {!check() == false && data.question != "No" ? (
        <div
          className="ppv10 my-3 col-md-12"
          style={{
            flexWrap: "wrap",
            height: "auto",
            marginRight: "0px",
            minWidth: "248px",
            padding: "0px",
          }}
          hidden={
            ["79", "80", "81", "82", "83", "84", "85", "86"].includes(
              parentData.question_id
            )
              ? true
              : !check()
          }
        >
          <div
            className={
              parentData.question_id != "1"
                ? !["79", "80", "81", "82", "83", "84", "85", "86"].includes(
                    parentData.question_id
                  )
                  ? "col-md-12"
                  : "col-md-12 test-form-container addedClassHdfc"
                : "col-md-12 test-form-container"
            }
            style={{ marginRight: "7px" }}
          >
            <span
              className="nfh1 cash"
              style={{
                fontWeight: "600",
                display: data.question == "Yes" ? "none" : "block",
              }}
            >
              {data.question == "Yes"
                ? null
                : ["79", "80", "81", "82", "83", "84", "85", "86"].includes(
                    parentData.question_id
                  )
                ? `${data.question} added `
                : data.question}
            </span>
            {parentData.question_id == "1" ? (
              <AnswerSetOne
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : parentData.question_id == "2" ? (
              <AnswerSetTwo
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : parentData.question_id == "3" ? (
              <AnswerSetThree
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : parentData.question_id == "4" ? (
              <AnswerSetFour
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : parentData.question_id == "5" ? (
              <AnswerSetFive
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                deliverydate={deliveryDates}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : parentData.question_id == "6" ? (
              <AnswerSetSeven
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                deliverydate={deliveryDates}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : ["79", "80", "81", "82", "83", "84", "85", "86"].includes(
                parentData.question_id
              ) ? (
              <AnswerSetSix
                pindex={pindex}
                qdata={data}
                parentqData={parentData}
                deliverydate={deliveryDates}
                proposerData={proposerData}
                HDFCcheckedQuestion={HDFCcheckedQuestion}
                setHDFCcheckedQuestion={setHDFCcheckedQuestion}
                updateHDFCQAlist={updateHDFCQAlist}
              />
            ) : null}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export const AnswerSetOne = ({
  pindex,
  qdata,
  parentqData,
  value,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const [dataObj, setDataObj] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [1];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let val;

      for (let key in resultObjects) {
        if (resultObjects[key].hasOwnProperty(pindex)) {
          let data_one = resultObjects[key][pindex];

          let val = data_one.find(
            (item) => item.QuestionId == parentqData.question_id
          );
          if (val != undefined) {
            let newobject = val;

            if (newobject) {
              newobject.Options.map((item, index) => {
                if (item.OptionId == qdata.question_id) {
                  setDataObj(item);
                  return;
                }
              });
            }
          }
        }
      }
    }
  }, []);

  const normalizeDate = (dateString) => {
    if (dateString && dateString != "Invalid Date") {
      const [year, month, day] = dateString.split("-");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
  };

  return (
    <>
      <>
        {/* <Box className={`medical-test-form ${visible ? "show" : ""}`}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" className="medical-label">
              Disease Name
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              value={dataObj?.ExactDiagnosis || ""}
              size="small"
              placeholder="Enter Disease Name"
              className="medical-input"
              onChange={(e) => {
                updateHDFCQAlist({
                  name: "ExactDiagnosis",
                  value: e.target.value,
                  pindex: pindex,
                  qdata: qdata,
                  parentqData: parentqData,
                });
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" className="medical-label">
              Date of Diagnosis
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    className: "medical-input",
                  },
                }}
                format="DD/MM/YYYY"
                value={
                  dataObj?.DiagnosisDate
                    ? dayjs(normalizeDate(dataObj?.DiagnosisDate))
                    : ""
                }
                onChange={(e) => {
                  updateHDFCQAlist({
                    name: "DiagnosisDate",
                    value: getDate(e),
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </LocalizationProvider>
          </Grid>
        
          <Grid item xs={12}>
            <Typography variant="body2" className="medical-label">
              Last Consultation Date
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    className: "medical-input",
                  },
                }}
                format="DD/MM/YYYY"
                value={
                  dataObj?.ConsultationDate
                    ? dayjs(normalizeDate(dataObj?.ConsultationDate))
                    : ""
                }
                onChange={(e) => {
                  updateHDFCQAlist({
                    name: "ConsultationDate",
                    value: getDate(e),
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </LocalizationProvider>
          </Grid>
        
          <Grid item xs={12}>
        <Typography variant="body2" className="medical-label">
        Current Status
        </Typography>
        <TextField
        className="medical-input"
        select
        fullWidth
        SelectProps={{
        native: true,
        }}
        variant="outlined"
        name="CurrentStatus"
        size="small"
        value={dataObj?.CurrentStatus || ""}
        onChange={(e) =>
        updateHDFCQAlist({
        name: "CurrentStatus",
        value: e.target.value,
        pindex,
        qdata,
        parentqData,
        })
        }
        >
        <option value="" disabled>Select Current Status</option>
        <option value="Cured">Cured</option>
        <option value="Not treated">Not treated</option>
        <option value="Ongoing">Ongoing</option>
        </TextField>
        </Grid>
        
          <Grid item xs={12}>
            <Typography variant="body2" className="medical-label">
            Details of Treatment given
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              name="typeOfTest"
              size="small"
              placeholder="Enter Treatment Details"
              className="medical-input"
              value={dataObj?.TreatmentDetails ? dataObj?.TreatmentDetails : ""}
              onChange={(e) => {
                updateHDFCQAlist({
                  name: "TreatmentDetails",
                  value: e.target.value,
                  pindex: pindex,
                  qdata: qdata,
                  parentqData: parentqData,
                });
              }}
            />
          </Grid>
        
          <Grid item xs={12}>
                      <Typography variant="body2" className="medical-label">
                        Line of Management
                      </Typography>
                      <TextField
                        className="medical-input"
                        select
                        fullWidth
                        SelectProps={{
                          native: true,
                        }}
                        variant="outlined"
                        name="CurrentStatus"
                        size="small"
                        value={
                          dataObj?.LineOfManagement
                            ? dataObj?.LineOfManagement
                            : ""
                        }
                        onChange={(e) => {
                          updateHDFCQAlist({
                            name: "LineOfManagement",
                            value: e.target.value,
                            pindex: pindex,
                            qdata: qdata,
                            parentqData: parentqData,
                          });
                        }}
                      >
                        <option value="" disabled>
                          Select Line of Management
                        </option>
                        <option value="Cured">Medical Management</option>
                        <option value="Not treated">Surgical Management</option>
                      </TextField>
                    </Grid>
        </Grid>
        </Box> */}

        <Box
          className={`medical-test-form que-one-family ${
            visible ? "show" : ""
          }`}
          key={JSON.stringify(dataObj || {})}
        >
          {/* {console.log("the dataobj in set one ", dataObj)} */}
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Disease Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                defaultValue={dataObj?.ExactDiagnosis || ""}
                size="small"
                placeholder="Enter Disease Name"
                className="medical-input"
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "ExactDiagnosis",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Diagnosis
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          // value: getDate(e),
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex: pindex,
                          qdata: qdata,
                          parentqData: parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj?.DiagnosisDate))
                      : null
                  }
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj.DiagnosisDate))
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "DiagnosisDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;

                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);
                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw);
                        }

                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Last Consultation Date
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "ConsultationDate",
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.ConsultationDate
                      ? dayjs(normalizeDate(dataObj?.ConsultationDate))
                      : null
                  }
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.ConsultationDate
                      ? dayjs(normalizeDate(dataObj.ConsultationDate))
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "ConsultationDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;

                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);
                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw); // fallback for flexible input
                        }

                        updateHDFCQAlist({
                          name: "ConsultationDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Current Status
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                defaultValue={dataObj?.CurrentStatus || ""}
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "CurrentStatus",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              >
                <option value="" disabled>
                  Select Current Status
                </option>
                <option value="Cured">Cured</option>
                <option value="Not treated">Not treated</option>
                <option value="Ongoing">Ongoing</option>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Details of Treatment given
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                name="typeOfTest"
                size="small"
                placeholder="Enter Treatment Details"
                className="medical-input"
                defaultValue={
                  dataObj?.TreatmentDetails ? dataObj?.TreatmentDetails : ""
                }
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "TreatmentDetails",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Line of Management
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                defaultValue={
                  dataObj?.LineOfManagement ? dataObj?.LineOfManagement : ""
                }
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "LineOfManagement",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              >
                <option value="" disabled>
                  Select Line of Management
                </option>
                <option value="Medical Management">Medical Management</option>
                <option value="Surgical Management">Surgical Management</option>
              </TextField>
            </Grid>
          </Grid>
        </Box>
      </>
    </>
  );
};

export const AnswerSetTwo = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const dispatch = useDispatch();

  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [2];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  const normalizeDate = (dateString) => {
    if (dateString && dateString != "Invalid Date") {
      const [year, month, day] = dateString.split("-");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
  };

  return (
    <>
      <>
        {/* <Box className={`medical-test-form ${visible ? "show" : ""}`}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Disease Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                value={dataObj?.Options[0]?.ExactDiagnosis || ""}
                size="small"
                placeholder="Enter Disease Name"
                className="medical-input"
                onChange={(e) => {
                  updateHDFCQAlist({
                    name: "ExactDiagnosis",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Diagnosis
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                    },
                  }}
                  format="DD/MM/YYYY"
                  value={
                    dataObj?.Options[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                      : ""
                  }
                  onChange={(e) => {
                    updateHDFCQAlist({
                      name: "DiagnosisDate",
                      value: getDate(e),
                      pindex: pindex,
                      qdata: qdata,
                      parentqData: parentqData,
                    });
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Surgery
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                    },
                  }}
                  format="DD/MM/YYYY"
                  value={
                    dataObj?.Options[0]?.SurgeryDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.SurgeryDate))
                      : ""
                  }
                  onChange={(e) => {
                    updateHDFCQAlist({
                      name: "SurgeryDate",
                      value: getDate(e),
                      pindex: pindex,
                      qdata: qdata,
                      parentqData: parentqData,
                    });
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Current Status
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                value={dataObj?.Options[0]?.CurrentStatus || ""}
                onChange={(e) =>
                  updateHDFCQAlist({
                    name: "CurrentStatus",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              >
                <option value="" disabled>
                  Select Current Status
                </option>
                <option value="Cured">Cured</option>
                <option value="Not treated">Not treated</option>
                <option value="Ongoing">Ongoing</option>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Details of your past surgery
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                name="typeOfTest"
                size="small"
                placeholder="Enter Treatment Details"
                className="medical-input"
                value={dataObj?.Options[0]?.SurgeryDetails || ""}
                onChange={(e) =>
                  updateHDFCQAlist({
                    name: "SurgeryDetails",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              />
            </Grid>
          </Grid>
        </Box> */}

        <Box
          className={`medical-test-form ${visible ? "show" : ""}`}
          key={JSON.stringify(dataObj?.Options[0] || {})}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Disease Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                defaultValue={dataObj?.Options[0]?.ExactDiagnosis || ""}
                size="small"
                placeholder="Enter Disease Name"
                className="medical-input"
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "ExactDiagnosis",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Diagnosis
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      // onBlur: (e) => {
                      //   updateHDFCQAlist({
                      //     name: "DiagnosisDate",
                      //     value: e.target.value
                      //       ? dayjs(e.target.value, "DD/MM/YYYY").format(
                      //           "YYYY-MM-DD"
                      //         )
                      //       : "",
                      //     pindex: pindex,
                      //     qdata: qdata,
                      //     parentqData: parentqData,
                      //   });
                      // },

                      onBlur: (e) => {
                        const raw = e.target.value;

                        console.log("Date input on blur:", e.target.value);

                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true); // strict
                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw); // fallback
                        }

                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                      : ""
                  }
                />
              </LocalizationProvider> */}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "DiagnosisDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;

                        // console.log("Date input on blur:", raw);

                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true); // strict parsing
                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw); // fallback parsing
                        }

                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Surgery
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "SurgeryDate",
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex: pindex,
                          qdata: qdata,
                          parentqData: parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.SurgeryDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.SurgeryDate))
                      : ""
                  }
                />
              </LocalizationProvider> */}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.SurgeryDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.SurgeryDate))
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "SurgeryDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;

                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);
                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw);
                        }

                        updateHDFCQAlist({
                          name: "SurgeryDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Current Status
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                defaultValue={dataObj?.Options[0]?.CurrentStatus || ""}
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "CurrentStatus",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              >
                <option value="" disabled>
                  Select Current Status
                </option>
                <option value="Cured">Cured</option>
                <option value="Not treated">Not treated</option>
                <option value="Ongoing">Ongoing</option>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Details of your past surgery
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                name="typeOfTest"
                size="small"
                placeholder="Enter Treatment Details"
                className="medical-input"
                defaultValue={dataObj?.Options[0]?.SurgeryDetails || ""}
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "SurgeryDetails",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              />
            </Grid>
          </Grid>
        </Box>
      </>
    </>
  );
};

export const AnswerSetThree = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const dispatch = useDispatch();

  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [3];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  const normalizeDate = (dateString) => {
    if (dateString && dateString != "Invalid Date") {
      const [year, month, day] = dateString.split("-");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
  };

  return (
    <>
      <>
        {/* <Box className={`medical-test-form ${visible ? "show" : ""}`}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Disease Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                value={dataObj?.Options[0]?.ExactDiagnosis || ""}
                size="small"
                placeholder="Enter Disease Name"
                className="medical-input"
                onChange={(e) => {
                  updateHDFCQAlist({
                    name: "ExactDiagnosis",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Diagnosis
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                    },
                  }}
                  format="DD/MM/YYYY"
                  value={
                    dataObj?.Options[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                      : ""
                  }
                  onChange={(e) => {
                    updateHDFCQAlist({
                      name: "DiagnosisDate",
                      value: getDate(e),
                      pindex: pindex,
                      qdata: qdata,
                      parentqData: parentqData,
                    });
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Last Consultation Date
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                    },
                  }}
                  format="DD/MM/YYYY"
                  value={
                    dataObj?.Options[0]?.ConsultationDate
                      ? dayjs(
                          normalizeDate(dataObj?.Options[0]?.ConsultationDate)
                        )
                      : ""
                  }
                  onChange={(e) => {
                    updateHDFCQAlist({
                      name: "ConsultationDate",
                      value: getDate(e),
                      pindex: pindex,
                      qdata: qdata,
                      parentqData: parentqData,
                    });
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Current Status
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                value={dataObj?.Options[0]?.CurrentStatus || ""}
                onChange={(e) =>
                  updateHDFCQAlist({
                    name: "CurrentStatus",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              >
                <option value="" disabled>
                  Select Current Status
                </option>
                <option value="Cured">Cured</option>
                <option value="Not treated">Not treated</option>
                <option value="Ongoing">Ongoing</option>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Treatment Details
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                name="typeOfTest"
                size="small"
                placeholder="Enter Treatment Details"
                className="medical-input"
                value={dataObj?.Options[0]?.TreatmentDetails || ""}
                onChange={(e) => {
                  updateHDFCQAlist({
                    name: "TreatmentDetails",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>
          </Grid>
        </Box> */}

        <Box
          className={`medical-test-form ${visible ? "show" : ""}`}
          key={JSON.stringify(dataObj?.Options[0] || {})}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Disease Name
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                defaultValue={dataObj?.Options[0]?.ExactDiagnosis || ""}
                size="small"
                placeholder="Enter Disease Name"
                className="medical-input"
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "ExactDiagnosis",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Date of Diagnosis
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex: pindex,
                          qdata: qdata,
                          parentqData: parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                      : ""
                  }
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.DiagnosisDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "DiagnosisDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;

                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);
                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw);
                        }

                        updateHDFCQAlist({
                          name: "DiagnosisDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Last Consultation Date
              </Typography>
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        updateHDFCQAlist({
                          name: "ConsultationDate",
                          value: e.target.value
                            ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                "YYYY-MM-DD"
                              )
                            : "",
                          pindex: pindex,
                          qdata: qdata,
                          parentqData: parentqData,
                        });
                      },
                    },
                  }}
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.ConsultationDate
                      ? dayjs(
                          normalizeDate(dataObj?.Options[0]?.ConsultationDate)
                        )
                      : ""
                  }
                />
              </LocalizationProvider> */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="DD/MM/YYYY"
                  defaultValue={
                    dataObj?.Options[0]?.ConsultationDate
                      ? dayjs(
                          normalizeDate(dataObj?.Options[0]?.ConsultationDate)
                        )
                      : null
                  }
                  onAccept={(newValue) => {
                    updateHDFCQAlist({
                      name: "ConsultationDate",
                      value: newValue
                        ? dayjs(newValue).format("YYYY-MM-DD")
                        : "",
                      pindex,
                      qdata,
                      parentqData,
                    });
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      onBlur: (e) => {
                        const raw = e.target.value;

                        let parsedDate = dayjs(raw, "DD/MM/YYYY", true);
                        if (!parsedDate.isValid()) {
                          parsedDate = dayjs(raw);
                        }

                        updateHDFCQAlist({
                          name: "ConsultationDate",
                          value: parsedDate.isValid()
                            ? parsedDate.format("YYYY-MM-DD")
                            : "",
                          pindex,
                          qdata,
                          parentqData,
                        });
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Current Status
              </Typography>
              <TextField
                className="medical-input"
                select
                fullWidth
                SelectProps={{
                  native: true,
                }}
                variant="outlined"
                name="CurrentStatus"
                size="small"
                defaultValue={dataObj?.Options[0]?.CurrentStatus || ""}
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "CurrentStatus",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              >
                <option value="" disabled>
                  Select Current Status
                </option>
                <option value="Cured">Cured</option>
                <option value="Not treated">Not treated</option>
                <option value="Ongoing">Ongoing</option>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Treatment Details
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                name="typeOfTest"
                size="small"
                placeholder="Enter Treatment Details"
                className="medical-input"
                defaultValue={dataObj?.Options[0]?.TreatmentDetails || ""}
                onBlur={(e) => {
                  updateHDFCQAlist({
                    name: "TreatmentDetails",
                    value: e.target.value,
                    pindex: pindex,
                    qdata: qdata,
                    parentqData: parentqData,
                  });
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </>
    </>
  );
};

export const AnswerSetFour = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [4];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  const normalizeDate = (dateString) => {
    if (dateString && dateString != "Invalid Date") {
      const [year, month, day] = dateString.split("-");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
  };

  return (
    <>
      <>
        {/* <Box className={`medical-test-form ${visible ? "show" : ""}`}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body2" className="medical-label">
                    Test Finding
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="testFinding"
                    size="small"
                    placeholder="Enter test finding"
                    className="medical-input"
                    value={dataObj?.Options[0]?.TestFinding || ""}
                    onChange={(e) =>
                      updateHDFCQAlist({
                        name: "TestFinding",
                        value: e.target.value,
                        pindex,
                        qdata,
                        parentqData,
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" className="medical-label">
                    Test Date
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          className: "medical-input",
                        },
                      }}
                      format="DD/MM/YYYY"
                      value={
                        dataObj?.Options[0]?.TestDate
                          ? dayjs(normalizeDate(dataObj?.Options[0]?.TestDate))
                          : ""
                      }
                      onChange={(e) =>
                        updateHDFCQAlist({
                          name: "TestDate",
                          value: getDate(e),
                          pindex,
                          qdata,
                          parentqData,
                        })
                      }
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" className="medical-label">
                    Type of Test
                  </Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="typeOfTest"
                    size="small"
                    placeholder="Enter type of test"
                    className="medical-input"
                    value={dataObj?.Options[0]?.TypeOfTest || ""}
                    onChange={(e) =>
                      updateHDFCQAlist({
                        name: "TypeOfTest",
                        value: e.target.value,
                        pindex,
                        qdata,
                        parentqData,
                      })
                    }
                  />
                </Grid>
              </Grid>
            </Box> */}

        <Box
          className={`medical-test-form ${visible ? "show" : ""}`}
          key={JSON.stringify(dataObj?.Options[0] || {})}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Test Finding
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                name="testFinding"
                size="small"
                placeholder="Enter test finding"
                className="medical-input"
                defaultValue={dataObj?.Options[0]?.TestFinding || ""}
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "TestFinding",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              />
            </Grid>
            <Grid item xs={12}>
              {/* <Typography variant="body2" className="medical-label">
                    Test Date
                  </Typography> */}
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          className: "medical-input",
                        },
                      }}
                      format="DD/MM/YYYY"
                      defaultValue={
                        dataObj?.Options[0]?.TestDate
                          ? dayjs(normalizeDate(dataObj?.Options[0]?.TestDate))
                          : null
                      }
                      onChange={(date) =>
                        updateHDFCQAlist({
                          name: "TestDate",
                          value: date ? date.format("YYYY-MM-DD") : "",
                          pindex,
                          qdata,
                          parentqData,
                        })
                      }
                    />
                  </LocalizationProvider> */}
              <Grid item xs={12}>
                <Typography variant="body2" className="medical-label">
                  Test Date
                </Typography>
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        className: "medical-input",
                        onBlur: (e) => {
                          updateHDFCQAlist({
                            name: "TestDate",
                            value: e.target.value
                              ? dayjs(e.target.value, "DD/MM/YYYY").format(
                                  "YYYY-MM-DD"
                                )
                              : "",
                            pindex,
                            qdata,
                            parentqData,
                          });
                        },
                      },
                    }}
                    format="DD/MM/YYYY"
                    defaultValue={
                      dataObj?.Options[0]?.TestDate
                        ? dayjs(normalizeDate(dataObj?.Options[0]?.TestDate))
                        : null
                    }
                  />
                </LocalizationProvider> */}

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    format="DD/MM/YYYY"
                    defaultValue={
                      dataObj?.Options[0]?.TestDate
                        ? dayjs(normalizeDate(dataObj?.Options[0]?.TestDate))
                        : null
                    }
                    onAccept={(newValue) => {
                      updateHDFCQAlist({
                        name: "TestDate",
                        value: newValue
                          ? dayjs(newValue).format("YYYY-MM-DD")
                          : "",
                        pindex,
                        qdata,
                        parentqData,
                      });
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        className: "medical-input",
                        onBlur: (e) => {
                          const raw = e.target.value;

                          let parsedDate = dayjs(raw, "DD/MM/YYYY", true);
                          if (!parsedDate.isValid()) {
                            parsedDate = dayjs(raw);
                          }

                          updateHDFCQAlist({
                            name: "TestDate",
                            value: parsedDate.isValid()
                              ? parsedDate.format("YYYY-MM-DD")
                              : "",
                            pindex,
                            qdata,
                            parentqData,
                          });
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Type of Test
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                name="typeOfTest"
                size="small"
                placeholder="Enter type of test"
                className="medical-input"
                defaultValue={dataObj?.Options[0]?.TypeOfTest || ""}
                onBlur={(e) =>
                  updateHDFCQAlist({
                    name: "TypeOfTest",
                    value: e.target.value,
                    pindex,
                    qdata,
                    parentqData,
                  })
                }
              />
            </Grid>
          </Grid>
        </Box>
      </>
    </>
  );
};
export const AnswerSetFive = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const dispatch = useDispatch();

  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [5];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  const normalizeDate = (dateString) => {
    if (dateString && dateString != "Invalid Date") {
      const [year, month, day] = dateString.split("-");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
  };

  return (
    <>
      {/* 
           <Box className={`medical-test-form ${visible ? "show" : ""}`}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="body2" className="medical-label">
                        Disease or Injury Details
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={dataObj?.Options[0]?.ExactDiagnosis || ""}
                        size="small"
                        placeholder="Enter Disease Details"
                        className="medical-input"
                        onChange={(e) =>
                          updateHDFCQAlist({
                            name: "ExactDiagnosis",
                            value: e.target.value,
                            pindex,
                            qdata,
                            parentqData,
                          })
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" className="medical-label">
                        Date of Diagnosis
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              className: "medical-input",
                            },
                          }}
                          format="DD/MM/YYYY"
                          value={
                            dataObj?.Options[0]?.DiagnosisDate
                              ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                              : ""
                          }
                          onChange={(e) => {
                            updateHDFCQAlist({
                              name: "DiagnosisDate",
                              value: getDate(e),
                              pindex: pindex,
                              qdata: qdata,
                              parentqData: parentqData,
                            });
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
        
                    <Grid item xs={12}>
                      <Typography variant="body2" className="medical-label">
                        Consultation Date
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              className: "medical-input",
                            },
                          }}
                          format="DD/MM/YYYY"
                          value={
                            dataObj?.Options[0]?.ConsultationDate
                              ? dayjs(
                                  normalizeDate(dataObj?.Options[0]?.ConsultationDate)
                                )
                              : ""
                          }
                          onChange={(e) => {
                            updateHDFCQAlist({
                              name: "ConsultationDate",
                              value: getDate(e),
                              pindex: pindex,
                              qdata: qdata,
                              parentqData: parentqData,
                            });
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
        
                    <Grid item xs={12}>
                      <Typography variant="body2" className="medical-label">
                        Current Status
                      </Typography>
                      <TextField
                        className="medical-input"
                        select
                        fullWidth
                        SelectProps={{
                          native: true,
                        }}
                        variant="outlined"
                        name="CurrentStatus"
                        size="small"
                        value={dataObj?.Options[0]?.CurrentStatus || ""}
                        onChange={(e) =>
                          updateHDFCQAlist({
                            name: "CurrentStatus",
                            value: e.target.value,
                            pindex,
                            qdata,
                            parentqData,
                          })
                        }
                      >
                        <option value="" disabled>
                          Select Current Status
                        </option>
                        <option value="Cured">Cured</option>
                        <option value="Not treated">Not treated</option>
                        <option value="Ongoing">Ongoing</option>
                      </TextField>
                    </Grid>
        
                    <Grid item xs={12}>
                      <Typography variant="body2" className="medical-label">
                        Treatment Details
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        name="typeOfTest"
                        size="small"
                        placeholder="Enter Treatment Details"
                        className="medical-input"
                        value={dataObj?.Options[0]?.TreatmentDetails || ""}
                        onChange={(e) => {
                          updateHDFCQAlist({
                            name: "TreatmentDetails",
                            value: e.target.value,
                            pindex: pindex,
                            qdata: qdata,
                            parentqData: parentqData,
                          });
                        }}
                      />
                    </Grid>
        
                    <Grid item xs={12}>
                      <Typography variant="body2" className="medical-label">
                        Line of Management
                      </Typography>
                      <TextField
                        className="medical-input"
                        select
                        fullWidth
                        SelectProps={{
                          native: true,
                        }}
                        variant="outlined"
                        name="CurrentStatus"
                        size="small"
                        value={
                          dataObj?.Options[0]?.LineOfManagement
                            ? dataObj?.Options[0]?.LineOfManagement
                            : ""
                        }
                        onChange={(e) => {
                          updateHDFCQAlist({
                            name: "LineOfManagement",
                            value: e.target.value,
                            pindex: pindex,
                            qdata: qdata,
                            parentqData: parentqData,
                          });
                        }}
                      >
                        <option value="" disabled>
                          Select Line of Management
                        </option>
                        <option value="Cured">Medical Management</option>
                        <option value="Not treated">Surgical Management</option>
                      </TextField>
                    </Grid>
                  </Grid>
                </Box> */}
      <Box
        className={`medical-test-form ${visible ? "show" : ""}`}
        key={JSON.stringify(dataObj?.Options[0] || {})}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" className="medical-label">
              Disease or Injury Details
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              defaultValue={dataObj?.Options[0]?.ExactDiagnosis || ""}
              size="small"
              placeholder="Enter Disease Details"
              className="medical-input"
              onBlur={(e) =>
                updateHDFCQAlist({
                  name: "ExactDiagnosis",
                  value: e.target.value,
                  pindex,
                  qdata,
                  parentqData,
                })
              }
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" className="medical-label">
              Date of Diagnosis
            </Typography>
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    className: "medical-input",
                    onBlur: (e) => {
                      updateHDFCQAlist({
                        name: "DiagnosisDate",
                        value: e.target.value
                          ? dayjs(e.target.value, "DD/MM/YYYY").format(
                              "YYYY-MM-DD"
                            )
                          : "",
                        pindex: pindex,
                        qdata: qdata,
                        parentqData: parentqData,
                      });
                    },
                  },
                }}
                format="DD/MM/YYYY"
                defaultValue={
                  dataObj?.Options[0]?.DiagnosisDate
                    ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                    : ""
                }
              />
            </LocalizationProvider> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD/MM/YYYY"
                defaultValue={
                  dataObj?.Options[0]?.DiagnosisDate
                    ? dayjs(normalizeDate(dataObj?.Options[0]?.DiagnosisDate))
                    : null
                }
                onAccept={(newValue) => {
                  updateHDFCQAlist({
                    name: "DiagnosisDate",
                    value: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "",
                    pindex,
                    qdata,
                    parentqData,
                  });
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    className: "medical-input",
                    onBlur: (e) => {
                      const raw = e.target.value;

                      let parsedDate = dayjs(raw, "DD/MM/YYYY", true);
                      if (!parsedDate.isValid()) {
                        parsedDate = dayjs(raw);
                      }

                      updateHDFCQAlist({
                        name: "DiagnosisDate",
                        value: parsedDate.isValid()
                          ? parsedDate.format("YYYY-MM-DD")
                          : "",
                        pindex,
                        qdata,
                        parentqData,
                      });
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" className="medical-label">
              Consultation Date
            </Typography>
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    className: "medical-input",
                    onBlur: (e) => {
                      updateHDFCQAlist({
                        name: "ConsultationDate",
                        value: e.target.value
                          ? dayjs(e.target.value, "DD/MM/YYYY").format(
                              "YYYY-MM-DD"
                            )
                          : "",
                        pindex: pindex,
                        qdata: qdata,
                        parentqData: parentqData,
                      });
                    },
                  },
                }}
                format="DD/MM/YYYY"
                defaultValue={
                  dataObj?.Options[0]?.ConsultationDate
                    ? dayjs(
                        normalizeDate(dataObj?.Options[0]?.ConsultationDate)
                      )
                    : ""
                }
              />
            </LocalizationProvider> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD/MM/YYYY"
                defaultValue={
                  dataObj?.Options[0]?.ConsultationDate
                    ? dayjs(
                        normalizeDate(dataObj?.Options[0]?.ConsultationDate)
                      )
                    : null
                }
                onAccept={(newValue) => {
                  updateHDFCQAlist({
                    name: "ConsultationDate",
                    value: newValue ? dayjs(newValue).format("YYYY-MM-DD") : "",
                    pindex,
                    qdata,
                    parentqData,
                  });
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    className: "medical-input",
                    onBlur: (e) => {
                      const raw = e.target.value;

                      let parsedDate = dayjs(raw, "DD/MM/YYYY", true);
                      if (!parsedDate.isValid()) {
                        parsedDate = dayjs(raw);
                      }

                      updateHDFCQAlist({
                        name: "ConsultationDate",
                        value: parsedDate.isValid()
                          ? parsedDate.format("YYYY-MM-DD")
                          : "",
                        pindex,
                        qdata,
                        parentqData,
                      });
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" className="medical-label">
              Current Status
            </Typography>
            <TextField
              className="medical-input"
              select
              fullWidth
              SelectProps={{
                native: true,
              }}
              variant="outlined"
              name="CurrentStatus"
              size="small"
              defaultValue={dataObj?.Options[0]?.CurrentStatus || ""}
              onBlur={(e) =>
                updateHDFCQAlist({
                  name: "CurrentStatus",
                  value: e.target.value,
                  pindex,
                  qdata,
                  parentqData,
                })
              }
            >
              <option value="" disabled>
                Select Current Status
              </option>
              <option value="Cured">Cured</option>
              <option value="Not treated">Not treated</option>
              <option value="Ongoing">Ongoing</option>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" className="medical-label">
              Treatment Details
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              name="typeOfTest"
              size="small"
              placeholder="Enter Treatment Details"
              className="medical-input"
              defaultValue={dataObj?.Options[0]?.TreatmentDetails || ""}
              onBlur={(e) => {
                updateHDFCQAlist({
                  name: "TreatmentDetails",
                  value: e.target.value,
                  pindex: pindex,
                  qdata: qdata,
                  parentqData: parentqData,
                });
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="body2" className="medical-label">
              Line of Management
            </Typography>
            <TextField
              className="medical-input"
              select
              fullWidth
              SelectProps={{
                native: true,
              }}
              variant="outlined"
              name="CurrentStatus"
              size="small"
              defaultValue={
                dataObj?.Options[0]?.LineOfManagement
                  ? dataObj?.Options[0]?.LineOfManagement
                  : ""
              }
              onBlur={(e) => {
                updateHDFCQAlist({
                  name: "LineOfManagement",
                  value: e.target.value,
                  pindex: pindex,
                  qdata: qdata,
                  parentqData: parentqData,
                });
              }}
            >
              <option value="" disabled>
                Select Line of Management
              </option>
              <option value="Medical Management">Medical Management</option>
              <option value="Surgical Management">Surgical Management</option>
            </TextField>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export const AnswerSetSeven = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [6];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  const normalizeDate = (dateString) => {
    if (dateString && dateString != "Invalid Date") {
      const [year, month, day] = dateString.split("-");
      const paddedMonth = month.padStart(2, "0");
      const paddedDay = day.padStart(2, "0");
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
  };

  return (
    <>
      <>
        {/* <Box className={`medical-test-form ${visible ? "show" : ""}`}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="body2" className="medical-label">
                        Delivery Date
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              className: "medical-input",
                            },
                          }}
                          format="DD/MM/YYYY"
                          value={
                            dataObj?.Options[0]?.DeliveryDate
                              ? dayjs(normalizeDate(dataObj?.Options[0]?.DeliveryDate))
                              : ""
                          }
                          onChange={(e) => {
                            updateHDFCQAlist({
                              name: "DeliveryDate",
                              value: getDate(e),
                              pindex: pindex,
                              qdata: qdata,
                              parentqData: parentqData,
                            });
                          }}
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Box> */}
        <Box className={`medical-test-form ${visible ? "show" : ""}`}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body2" className="medical-label">
                Delivery Date
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      className: "medical-input",
                      readOnly: true,
                    },
                  }}
                  format="DD/MM/YYYY"
                  minDate={dayjs()}
                  value={
                    dataObj?.Options[0]?.DeliveryDate
                      ? dayjs(normalizeDate(dataObj?.Options[0]?.DeliveryDate))
                      : ""
                  }
                  onChange={(e) => {
                    updateHDFCQAlist({
                      name: "DeliveryDate",
                      value: getDate(e),
                      pindex: pindex,
                      qdata: qdata,
                      parentqData: parentqData,
                    });
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </Box>
      </>
    </>
  );
};
export const AnswerSetEight = ({
  pindex,
  qdata,
  parentqData,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const [dataObj, setDataObj] = useState();
  const [checkedData, setCheckedData] = useState();

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [6];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  return (
    <>
      <Checkbox
        checked={
          dataObj?.Options[0] &&
          dataObj?.Options[0].OptionId == qdata.question_id
            ? true
            : false
        }
        // checked={checkedData}
        inputProps={{ "aria-label": "controlled" }}
        onChange={(e) => {
          updateHDFCQAlist({
            name: "data",
            value: e.target.checked,
            pindex: pindex,
            qdata: qdata,
            parentqData: parentqData,
          });
        }}
      />
    </>
  );
};

export const AnswerSetSix = ({
  pindex,
  qdata,
  parentqData,
  deliverydate,
  proposerData,
  HDFCcheckedQuestion,
  setHDFCcheckedQuestion,
  updateHDFCQAlist,
}) => {
  const [dataObj, setDataObj] = useState();

  useEffect(() => {
    if (HDFCcheckedQuestion) {
      const keys = Object.keys(HDFCcheckedQuestion);
      const numbersToCheck = [79, 80, 81, 82, 83, 84, 85, 86];
      const anyNumberPresent = numbersToCheck.some((number) =>
        keys.includes(number.toString())
      );

      const resultObjects = numbersToCheck
        .filter((number) => keys.includes(number.toString()))
        .map((number) => HDFCcheckedQuestion[number.toString()]);

      let available = resultObjects[0].hasOwnProperty(pindex);

      if (available) {
        let data = resultObjects[0][pindex];

        if (data[0] == undefined) {
          return;
        }

        let newobject = data[0];

        if (newobject) {
          setDataObj(newobject);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (
      ["79", "80", "81", "82", "83", "84", "85", "86"].includes(
        parentqData.question_id
      )
    ) {
      updateHDFCQAlist({
        name: "data",
        value: true,
        pindex: pindex,
        qdata: qdata,
        parentqData: parentqData,
      });
    }
  }, []);

  return (
    <>
      <Checkbox
        checked={dataObj?.Options[0] ? true : false}
        inputProps={{ "aria-label": "controlled" }}
      />
    </>
  );
};
